module.exports = __webpack_public_path__ + "img/zaozhi_model.12a2b317.png";